import { TextField, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import dayjs from "dayjs";
import { setCancelDialog, LeaveUser } from "../../../app/slices/leaveUserSlice";
import {
  HiOutlineXCircle,
  HiOutlineChatBubbleLeftEllipsis,
} from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../components/FormDialog";

/** The rep cancelling one of their own pending requests. */
const LeaveCancelForm = () => {
  const _Cancel = useSelector((state) => state.leaveUser.cancel);
  const _SearchBody = useSelector((state) => state.leaveUser.searchBody);
  const dispatch = useDispatch();

  const { control, handleSubmit } = useForm({
    defaultValues: { comments: "" },
  });

  const onSubmit = (data) => {
    dispatch(
      LeaveUser.reject(_Cancel.data?.id, { comments: data.comments }, _SearchBody),
    );
  };

  return (
    <FormDialog
      open={_Cancel.dialog}
      onClose={() => dispatch(setCancelDialog())}
      maxWidth="xs"
      icon={<HiOutlineXCircle />}
      title="الغاء طلب الاجازة"
      subtitle={
        _Cancel.data?.start_date
          ? `من ${dayjs(_Cancel.data.start_date).format("YYYY-MM-DD")} الى ${
              _Cancel.data?.end_date
                ? dayjs(_Cancel.data.end_date).format("YYYY-MM-DD")
                : ""
            } - عدد الايام: ${_Cancel.data?.total_days ?? ""}`
          : null
      }
      onSubmit={handleSubmit(onSubmit)}
      saveText="تاكيد الالغاء"
      saveColor="error"
    >
      <SectionCard
        icon={<HiOutlineChatBubbleLeftEllipsis />}
        title="سبب الالغاء"
      >
        <Grid item xs={12}>
          <Controller
            name="comments"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="سبب الالغاء"
                multiline
                rows={3}
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default LeaveCancelForm;
